import * as React from 'react';

export class AppHeader extends React.Component {
  public render() {
    return (
      <div className="app-header">
        <img src="/assets/images/alaska-header-logo.png" alt="Alaska"/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/app/app-header.tsx